import type { ValueElementIdReferenceAPI } from '../../types/value';
import { getValueName } from '../values/selector/value-selector-utils';
import './css/value-reference-display.css';
import { CirclesThreePlus } from '@phosphor-icons/react';

interface Props {
    valueReference: ValueElementIdReferenceAPI;
}

const ValueReferenceDisplay = ({ valueReference }: Props) => {
    const name = getValueName(valueReference);

    return (
        <span className="value-reference-display" title={`Value reference: ${name}`}>
            <CirclesThreePlus className="value-reference-display-icon" width="18" height="18" />
            <span className="value-reference-display-name">{name}</span>
        </span>
    );
};

export default ValueReferenceDisplay;
